type RejectablePromise<T> = {
  id: string;
  promise: () => Promise<T>;
  // https://linear.app/air/issue/ENG-109/update-dragitemtypedefault-to-not-use-any
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  reject: (reason?: any) => void;
};

const PROMISE_CANCELLED = 'Promise was cancelled';

/**
 * This class runs promises in LIFO queue
 */
export class PromiseQueue<T> {
  private queue: RejectablePromise<T>[] = [];
  private running = false;

  run = (id: string, promise: () => Promise<T>): Promise<T> => {
    const existingPromise = this.queue.find((p) => p.id === id);
    if (existingPromise) {
      return existingPromise.promise();
    }

    return new Promise((resolve, reject) => {
      const task = () =>
        promise()
          .then((result) => {
            resolve(result);
            return result;
          })
          .catch((error) => {
            reject(error);
            throw error;
          });

      this.queue.push({
        id,
        promise: task,
        reject,
      });

      this.runNext();
    });
  };

  cancelAll = () => {
    const queue = [...this.queue];
    this.queue = [];

    for (const promise of queue) {
      promise.reject(PROMISE_CANCELLED);
    }
    this.running = false;
  };

  private runNext = () => {
    if (this.running || this.queue.length === 0) {
      return;
    }

    this.running = true;
    const nextTask = this.queue.shift();
    if (nextTask) {
      nextTask.promise().finally(() => {
        this.running = false;
        this.runNext();
      });
    }
  };
}
